var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "message-content" }, [
      _c("div", { staticClass: "notification" }, [
        _c("h4", [_vm._v(_vm._s(_vm.message))]),
      ]),
    ]),
    _c(
      "form",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "form",
        attrs: {
          method: "post",
          action: "https://www.servipag.com/BotonPago/BotonPago/Pagar",
        },
      },
      [
        _c("input", {
          attrs: { id: "xml", name: "xml", type: "text" },
          domProps: { value: _vm.xml },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }